// extracted by mini-css-extract-plugin
export default {"divider1":"Divider_divider1__lcpcS","spacer":"Divider_spacer__2Hp1D","mobileNone":"Divider_mobileNone__POoCg"};